export default __webpack_public_path__ + "static/media/line-items-group-icon.24030bd5.svg";